import api from '@/api/api'

export default {
    async shareMotifConsultation(reference) {
        return await api().post(`/cca-mobile/motifs-consultation/${reference}/share`)
    },
    async shareConstante(reference) {
        return await api().post(`/cca-mobile/constantes/${reference}/share`)
    },
    async shareExamenClinique(reference) {
        return await api().post(`/cca-mobile/examens-cliniques/${reference}/share`)
    },
    async shareDiagnostic(reference) {
        return await api().post(`/cca-mobile/diagnostics/${reference}/share`)
    },
    async shareOrdonnance(reference) {
        return await api().post(`/cca-mobile/ordonnances/${reference}/share`)
    },
    async shareComment(reference) {
        return await api().post(`/cca-mobile/comments/${reference}/share`)
    },
}